import { render, staticRenderFns } from "./CrewLabor.vue?vue&type=template&id=1a81b258"
import script from "./CrewLabor.vue?vue&type=script&lang=js"
export * from "./CrewLabor.vue?vue&type=script&lang=js"
import style0 from "./CrewLabor.vue?vue&type=style&index=0&id=1a81b258&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports